import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/situacoes_registros${queryUrl}`)
  },
  insertNewRecordSituations(data) {
    return axios.post('/core/situacoes_registros', data)
  },
  editRecordSituations(data) {
    return axios.put(`/core/situacoes_registros/${data.id}`, data)
  },
  deleteRecordSituations(id) {
    return axios.delete(`/core/situacoes_registros/${id}`)
  },
}
